export const routeNamespace = 'templates';
